// extracted by mini-css-extract-plugin
export default {"LoginView":"LoginView_LoginView__hgzg-"};